module.exports = __webpack_public_path__ + "edc278959ce64130dc17b5de459dc3bc.svg";